import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Stack from '@mui/material/Stack';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import Members from '../Members';

function NewGroup({ users, createGroup, open, setOpen }) {
    const [groupName, setGroupName] = useState('');
    const [members, setMembers] = useState([]);

    const { t } = useTranslation();

    const submit = async () => {
        //  Data preparation
        const data = {
            name: groupName,
            members: members
        };

        const STATUS = await createGroup(data);
        if (STATUS) {
            setGroupName('');
            setMembers([]);
            setOpen(false);
        }
    }

    const addMember = (id) => {
        setMembers((prev) => {
            return [...prev, id];
        });
    };

    const removeMember = (id) => {
        setMembers((prev) => prev.filter((memberId) => memberId !== id));
    }

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Paper
                sx={{
                    padding: '24px',
                    minWidth: { xs: '95%', md: '35%' },
                    maxWidth: { xs: '95%', md: '35%' },
                }}
            >
                <Typography variant='h6' sx={{ mb: 4 }}>
                    {t('users.modals.newGroup.title')}
                </Typography>
                <Stack spacing={4}>
                    <TextField
                        id='mISLec_section_title'
                        label={t('users.modals.newGroup.input')}
                        variant='outlined'
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        fullWidth
                    />
                </Stack>
                <Stack sx={{ mt: 2 }}>
                    <Members
                        users={users}
                        members={members}
                        addMember={(id) => addMember(id)}
                        removeMember={(id) => removeMember(id)}
                    />
                </Stack>
                <Stack
                    direction='row'
                    alignItems='center'
                    mt={4}
                    sx={{
                        justifyContent: {
                            xs: 'space-between',
                            md: 'flex-end'
                        }
                    }}
                >
                    <Button
                        variant=''
                        onClick={() => setOpen(false)}
                        sx={{
                            borderRadius: '8px !important',
                            backgroundColor: (theme) => ({
                                xs: alpha(theme.palette.error.main, 0.08),
                                md: 'rgba(33, 43, 54, 0.08)'
                            }),
                            color: {
                                xs: 'error.main',
                                md: 'inherit'
                            },
                            '&:hover': {
                                color: 'error.main',
                                backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08)
                            }
                        }}
                    >
                        {t('users.modals.newGroup.cancel')}
                    </Button>
                    <Button
                        onClick={() => submit()}
                        sx={{
                            ml: {
                                xs: 0,
                                md: 1
                            },
                            borderRadius: '8px !important',
                            backgroundColor: (theme) => ({
                                xs: alpha(theme.palette.primary.main, 0.08),
                                md: 'rgba(33, 43, 54, 0.08)'
                            }),
                            color: {
                                xs: 'primary.main',
                                md: 'inherit'
                            },
                            '&:hover': {
                                color: 'primary.main',
                                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08)
                            }
                        }}
                    >
                        {t('users.modals.newGroup.create')}
                    </Button>
                </Stack>
            </Paper>
        </Modal>
    );
}

export default NewGroup;